/**
 * Mapy dla wiadomości w sekcji New Students
 */

export const ACCOUNT_NUMBERS = {
  Smart1: '02 1140 2004 0000 3702 3915 3387',
  Smart2: '49 1140 2004 0000 3002 8609 8265',
  Faktury1: '02 1140 2004 0000 3702 3915 3387',
  Faktury2: '49 1140 2004 0000 3002 8609 8265'
}

export const BLIK_NUMBER = '695714050'

export const getAccountNumber = (accountKey) => {
  const mapping = {
    account1: ACCOUNT_NUMBERS.Smart1,
    account2: ACCOUNT_NUMBERS.Smart2,
    account3: ACCOUNT_NUMBERS.Faktury1,
    account4: ACCOUNT_NUMBERS.Faktury2,
    account5: BLIK_NUMBER,
    Smart1: ACCOUNT_NUMBERS.Smart1,
    Smart2: ACCOUNT_NUMBERS.Smart2,
    Faktury1: ACCOUNT_NUMBERS.Faktury1,
    Faktury2: ACCOUNT_NUMBERS.Faktury2
  }
  return mapping[accountKey] ?? ACCOUNT_NUMBERS.Smart1
}

export const SUBJECT_EXPANSIONS = {
  'ang adult doA2': 'j. angielski do poziomu A2',
  'ang lic podst': 'j. angielski – liceum, podstawa',
  'ang lic rozsz': 'j. angielski – liceum, rozszerzenie',
  'ang sz.p.': 'j. angielski – szkoła podstawowa',
  'biol akad': 'biologia akademicka',
  'biol lic podst': 'biologia – liceum, podstawa',
  'biol lic rozsz': 'biologia – liceum, rozszerzenie',
  'biol sz.p.': 'biologia – szkoła podstawowa',
  'chem akad': 'chemia akademicka',
  'chem lic podst': 'chemia – liceum, podstawa',
  'chem lic rozsz': 'chemia – liceum, rozszerzenie',
  'chem sz.p.': 'chemia – szkoła podstawowa',
  'fiz akad': 'fizyka akademicka',
  'fiz lic podst': 'fizyka – liceum, podstawa',
  'fiz lic rozsz': 'fizyka – liceum, rozszerzenie',
  'fiz sz.p.': 'fizyka – szkoła podstawowa',
  'pol lic podst': 'j. polski – liceum, podstawa',
  'pol lic rozsz': 'j. polski – liceum, rozszerzenie',
  'pol sz.p.': 'j. polski – szkoła podstawowa',
  'mat akad': 'matematyka akademicka',
  'mat lic podst': 'matematyka – liceum, podstawa',
  'mat lic rozsz': 'matematyka – liceum, rozszerzenie',
  'mat sz.p.': 'matematyka – szkoła podstawowa',
  'ang matura': 'j. angielski – matura',
  'biol matura': 'biologia – matura',
  'chem matura': 'chemia – matura',
  'fiz matura': 'fizyka – matura',
  'mat matura podst': 'matematyka – matura, podstawa',
  'mat matura rozsz': 'matematyka – matura, rozszerzenie',
  'ang 8kl': 'j. angielski – 8 klasa',
  'chem 8kl': 'chemia – 8 klasa',
  'mat 8kl': 'matematyka – 8 klasa',
  'pol 8kl': 'j. polski – 8 klasa',
  'fiz 8kl': 'fizyka – 8 klasa',
  'pol matura': 'j. polski – matura',
  'ang adult odB1': 'j. angielski od poziomu B1',
  programowanie: 'programowanie'
}

export const getSubjectExpansion = (subjectKey) => {
  const key = (subjectKey || '').trim()
  const keyLower = key.toLowerCase()
  return SUBJECT_EXPANSIONS[key] ?? SUBJECT_EXPANSIONS[keyLower] ?? key ?? ''
}
